module.exports = __webpack_public_path__ + "img/kma_gallery12.b55e356e.jpg";